<section class="row alinhamento-centralizado-tablet-grande" id="top-form">
  <div class="col-12">
    <div class="">
      <div class="latest-blog-loop">
        <ng-container>
          <mat-horizontal-stepper
            [selectedIndex]="getStepIndexFromEnum(stepAtual)"
            [linear]="isLinear"
            #stepper
            style="height: 100vh !important"
          >
            <!-- Passo 1 - Cadastro -->
            <mat-step [label]="'CADASTRO' + quizEstiloDeVidaEnum.CADASTRO">
              <div>
                <div
                  class="card-block text-center"
                  [ngClass]="{'bg-white': !ehOrientacao}"
                >
                  <div>
                    <img
                      class="img-geia-top image-main logo-geia"
                      src="../../../../assets/app-assets/images/logo/logo-b-geia.png"
                    />
                  </div>
                </div>
                <!-- Cadastro -->
                <div *ngIf="!ehOrientacao; else orientacaoQuiz">
                  <div class="text-center pb-3 bg-white">
                    <h3 class="title-banner title preto-geia">
                      DESCUBRA O SEU
                    </h3>
                    <h3 class="sub-title-banner title">ESTILO DE VIDA</h3>
                  </div>
                  <div>
                    <div class="altura-div blank-page">
                      <div class="text-center container">
                        <div class="container__heading form-cadastro">
                          <div class="row">
                            <div
                              class="colunas col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            >
                              <div class="row mt-2">
                                <form [formGroup]="formQuiz" class="w-100">
                                  <div class="col-12 col-sm-12">
                                    <div class="form-group row">
                                      <!-- Nome -->
                                      <div
                                        class="form-group mb-1 col-sm-12 col-md-12"
                                        style="text-align: justify"
                                      >
                                        <label for="name">Nome</label>
                                        <input
                                          (ngModelChange)="onFieldChange()"
                                          type="text"
                                          class="form-control round"
                                          id="name"
                                          maxlength="250"
                                          formControlName="name"
                                          [ngClass]="{
                                            'is-invalid':
                                              formQuiz.controls['name']
                                                .errors && isFormSubmited
                                          }"
                                        />
                                        <app-validacao-form-input
                                          [nomeFormulario]="formQuiz"
                                          nomeCampo="name"
                                          [maxLength]="250"
                                          [minLength]="10"
                                          [isFormSubmited]="isFormSubmited"
                                        >
                                        </app-validacao-form-input>
                                      </div>
                                      <!-- E-mail -->
                                      <div
                                        class="form-group mb-1 col-sm-12 col-md-12"
                                        style="text-align: justify"
                                      >
                                        <label for="email">E-mail </label>
                                        <br />
                                        <input
                                          type="text"
                                          class="form-control round"
                                          id="email"
                                          formControlName="email"
                                          [maxlength]="249"
                                          (ngModelChange)="onFieldChange()"
                                          required
                                          [ngClass]="{
                                            'is-invalid':
                                              formQuiz.controls['email']
                                                .errors && isFormSubmited
                                          }"
                                        />
                                        <app-validacao-form-input
                                          [nomeFormulario]="formQuiz"
                                          nomeCampo="email"
                                          [maxLength]="250"
                                          [minLength]="5"
                                          [isFormSubmited]="isFormSubmited"
                                        >
                                        </app-validacao-form-input>
                                        <div
                                          class="errors"
                                          *ngIf="
                                            formQuiz.get('email')?.invalid &&
                                            (formQuiz.get('email')?.touched ||
                                              formQuiz.get('email')?.dirty)
                                          "
                                        >
                                          <div
                                            class="errors"
                                            *ngIf="
                                              formQuiz
                                                .get('email')
                                                ?.hasError('checkEmail')
                                            "
                                          >
                                            {{formQuiz.get('email')?.errors?.['checkEmail']}}
                                          </div>
                                        </div>
                                      </div>
                                      <!-- Telefone -->
                                      <div
                                        class="form-group mb-1 col-md-12 col-sm-12"
                                        style="text-align: justify"
                                      >
                                        <label for="phone"
                                          >Telefone (Opcional)</label
                                        >
                                        <input
                                          mask="(00) 00000-0000"
                                          [showMaskTyped]="true"
                                          class="round box-shadow-4 form-control"
                                          formControlName="phone"
                                          type="text"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <!-- Botão -->
                          <div class="button-mobile w-100 mt-4">
                            <div class="mb-2 col-sm-12">
                              <button
                                class="btn-simule btn btn-outline-secondary btn-min-width"
                                (click)="onCadastrar()"
                              >
                                COMEÇAR
                              </button>
                            </div>
                            <div class="mb-5 col-sm-12">
                              <button
                                class="btn-simule btn btn-outline-secondary btn-min-width"
                                (click)="onOrientacao(true)"
                              >
                                ORIENTAÇÃO
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Orientação -->
                <ng-template #orientacaoQuiz>
                  <div>
                    <div class="blank-page">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="row p-3 text-center">
                          <p class="preto-geia w-100">
                            Não existe certo ou errado,
                            <b
                              >basta responder com a alternativa com a qual mais
                              se identifica,</b
                            >
                            conforme a legenda a seguir:
                          </p>
                        </div>
                        <div class="row">
                          <div
                            class="text-center p-2 w-100"
                            *ngFor="let item of orientacao"
                            [style.background]="item.corClaro"
                          >
                            <h2 [style.color]="item.cor">
                              <b>{{ item.titulo }}</b>
                            </h2>
                            <p class="col-sm-12 col-md-12 preto-geia">
                              {{ item.texto }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Botão -->
                  <div
                    class="button-mobile d-flex justify-content-center w-100 mt-5 col-md-12 col-sm-12"
                  >
                    <button
                      class="btn-simule btn btn-outline-secondary btn-min-width"
                      (click)="onOrientacao(false)"
                    >
                      VOLTAR
                    </button>
                  </div>
                  <div class="p-3 text-center">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="row">
                        <p class="preto-geia w-100">
                          Avaliação pontual, sem caráter diagnóstico, baseada no
                          questionário PEVI, validado cientificamente para
                          avaliar o estilo de vida.
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </mat-step>
            <!-- Passo 2 - Perguntas -->
            <mat-step [label]="'PERGUNTAS' + quizEstiloDeVidaEnum.PERGUNTAS">
              <div class="mt-1 alinhamento-centralizado-tablet">
                <div class="card-block text-center">
                  <div>
                    <img
                      class="img-geia-top image-main logo-geia"
                      src="../../../../assets/app-assets/images/logo/logo-b-geia.png"
                    />
                  </div>
                </div>
                <!-- Barra de Progresso -->
                <div
                  class="progress-bar-container mb-3 mt-1 comprimento-barra-progresso"
                  style="width: 85%; margin: 2rem"
                >
                  <div
                    class="progress-bar"
                    [style.width]="progressoPercentual + '%'"
                  ></div>
                  <div class="progress-text">
                    <div class="progress-bar-container">
                      <div
                        class="progress-bar d-flex align-items-end"
                        [style.width]="progressoPercentual + '%'"
                      >
                        {{ progressoPercentual }}%
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngFor="let mensagem of mensagemCategoria"
                  class="comprimento-tablet-grande"
                >
                  <h3
                    class="card-title align-items-center m-1 pl-1 mensagem"
                    [style.border-left]="'10px solid ' + mensagem.cor"
                  >
                    <b class="preto-geia">{{ mensagem.texto }} </b>
                    <b [style.color]="mensagem.cor">{{ mensagem.categoria }}</b>
                  </h3>
                  <!-- Perguntas -->
                  <div
                    *ngFor="
                      let item of perguntasPorCategoria;
                      let indexPergunta = index
                    "
                    class="col-md-12"
                  >
                    <div class="row">
                      <div
                        [ngClass]="
                          indexPergunta === 0 ||
                          indexPergunta === perguntasPorCategoria.length - 1
                            ? 'bg-transparent'
                            : 'bg-white'
                        "
                      >
                        <div class="p-2 mb-0">
                          <div class="">
                            <h3 class="preto-geia pergunta">
                              <b [style.color]="mensagem.cor"
                                >{{ item.order.toLowerCase() }}.</b
                              >
                              {{ item.description }}
                            </h3>
                          </div>
                          <div class="card-body">
                            <div
                              *ngFor="let resposta of listaResposta"
                              class="form-check d-flex align-items-center"
                            >
                              <input
                                type="radio"
                                class="form-check-input me-2"
                                [id]="
                                  'pergunta-' +
                                  indexPergunta +
                                  '-resposta-' +
                                  resposta.valor
                                "
                                [name]="'pergunta-' + indexPergunta"
                                [value]="resposta.valor"
                                [(ngModel)]="item.response"
                                (change)="
                                  onFieldChange();
                                  onChangeRespostaQuiz(resposta.valor, item)
                                "
                              />
                              <label
                                class="form-check-label preto-geia"
                                [for]="
                                  'pergunta-' +
                                  indexPergunta +
                                  '-resposta-' +
                                  resposta.valor
                                "
                              >
                                {{ resposta.descricao }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-step>
            <!-- Passo 3 - Resultado -->
            <mat-step [label]="'RESULTADO' + quizEstiloDeVidaEnum.RESULTADO">
              <div class="card-block text-center" #resultado>
                <div>
                  <img
                    class="img-geia-top image-main logo-geia"
                    src="../../../../assets/app-assets/images/logo/logo-b-geia.png"
                  />
                </div>
              </div>
              <div
                class="text-center container mt-1 mb-4 position-relative resultado-container"
              >
                <h3 class="sub-title-banner title">RESULTADO</h3>
                <h3 class="title preto-geia titulo-resultado-quiz">
                  <span class="q-maiusculo">Q</span>uiz
                </h3>
              </div>

              <div class="text-center pt-3 pb-3 bg-white">
                <h3 class="title-banner title preto-geia">GRÁFICO</h3>
                <h3 class="sub-title-banner title">DAS DIMENSÕES</h3>
              </div>
              <!-- Gráfico -->
              <div
                class="row m-0 bg-white"
                *ngFor="let itemDoGrafico of grafico"
              >
                <div
                  class="col-6 d-flex align-items-center font-weight-bold nome-categoria"
                  [style.background]="itemDoGrafico.corClaro"
                >
                  <span
                    class="categoria-texto pl-2"
                    [style.color]="itemDoGrafico.cor"
                    >{{ itemDoGrafico.nome }}</span
                  >
                </div>

                <div class="col-6 d-flex p-0 grafico-coluna-container">
                  <div
                    class="coluna-grafico"
                    [style.background-color]="
                      itemDoGrafico.valor >= 3
                        ? itemDoGrafico.corClaro
                        : 'transparent'
                    "
                    [style.border-left]="'4px solid ' + itemDoGrafico.cor"
                  ></div>
                  <div
                    class="coluna-grafico"
                    [style.background-color]="
                      itemDoGrafico.valor >= 6
                        ? itemDoGrafico.corClaro
                        : 'transparent'
                    "
                    [style.border-left]="'4px solid ' + itemDoGrafico.cor"
                  ></div>
                  <div
                    class="coluna-grafico ultima-coluna"
                    [style.background-color]="
                      itemDoGrafico.valor > 6
                        ? itemDoGrafico.corClaro
                        : 'transparent'
                    "
                    [style.border-left]="'4px solid ' + itemDoGrafico.cor"
                    [style.border-right]="'4px solid ' + itemDoGrafico.cor"
                  ></div>
                </div>
              </div>
              <div class="row p-3 text-center bg-white">
                <p class="preto-geia w-100">
                  <b
                    >Neste gráfico você pode avaliar individualmente cada
                    dimensão do seu estilo de vida.</b
                  >
                </p>
                <p class="preto-geia">
                  <b>Quanto maior a barra, melhores são os seus hábitos.</b>
                  Então avalie o que precisa mudar e se precisar de ajuda, conte
                  com a gente!
                </p>
              </div>
              <!-- Mensagem Resultado Total -->
              <div
                class="p-2"
                *ngIf="mensagemResultado.length"
                [style.background]="mensagemResultado[0].corFundo"
              >
                <div class="d-flex margin-resultado-title-tablet">
                  <div class="col-sm-6 alinhamento-emoji-tablet">
                    <img
                      class="img-geia-top image-main"
                      [src]="mensagemResultado[0].img"
                    />
                  </div>
                  <div class="col-sm-6 d-flex align-items-center">
                    <h3 class="sub-title-banner title">SEU RESULTADO!</h3>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="row">
                    <p
                      [style.color]="mensagemResultado[0].corTexto"
                      [innerHTML]="mensagemResultado[0].mensagem"
                    ></p>
                  </div>
                </div>
              </div>
              <!-- Botão E-book -->
              <div
                class="button-mobile d-flex justify-content-center w-100 mt-5 col-md-12 col-sm-12"
              >
                <a
                  class="btn-simule btn btn-outline-secondary btn-min-width"
                  href="https://geiaerp.blob.core.windows.net/public-files/Ebook%20Conarh%20.pdf"
                  target="_blank"
                  download
                >
                  E-BOOK
                </a>
              </div>
              <div class="p-2 text-center">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="row">
                    <p class="preto-geia">
                      Que tal um e-book com dicas científicas para um estilo de
                      vida saudável, feito pela nossa equipe multiprofissional?
                    </p>
                  </div>
                </div>
              </div>
              <!-- Rodapé -->
              <div class="card-block text-center">
                <div>
                  <img
                    class="img-geia-top image-main"
                    src="../../../../assets/app-assets/images/logo/esfera-geia-azul-escuro.png"
                  />
                </div>
              </div>
              <div class="text-center container mb-3">
                <h3 class="sub-title-banner title">OBRIGADO</h3>
                <h3 class="title-banner title preto-geia">POR PARTICIPAR!</h3>
              </div>
            </mat-step>
          </mat-horizontal-stepper>
        </ng-container>
      </div>
    </div>
  </div>
</section>
